import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import reloadToken from '../helper/reloadtoken';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.min.css';
import HeaderMenu from '../template/HeaderMenu';

const host = process.env.REACT_APP_API_URL_ONLINE;
const hostupload = process.env.REACT_APP_API_HOST_UPLOAD;

const User_c_pass = () => {
  const hotRef = useRef(null);
  const [token, setToken] = useState(null);
  const [accessCode, setAccessCode] = useState('');
  const [colHeaders, setColHeaders] = useState([]);
  const widthLayout = window.innerWidth - 10;
  const heightLayout = window.innerHeight - 10;

  const changePass = async (e) => {
    e.preventDefault();
    const currentPassword = document.getElementById('currentPassword').value;
    const newPassword = document.getElementById('newPassword').value;
    const confirmPassword = document.getElementById('confirmPassword').value;
    if (newPassword !== confirmPassword) {
      alert('New Password and Confirm Password do not match');
      return;
    }
    const formData = new FormData();
    formData.append('currentPassword', currentPassword);
    formData.append('newPassword', newPassword);
    try {
      const response = await axios.post(`${host}master/cpass`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      alert(response.data.message);
      localStorage.setItem('pass', newPassword)
      // Redirect to login page
      window.location.href = '/';
    } catch (error) {
      console.error('Error changing password:', error);
      alert('Error changing password');
    }
  }
  useEffect( async () => {
    const newToken = await reloadToken();
    //console.log("test " + newToken);
    setToken(newToken);
    const config = {
      headers: {
        Authorization: `Bearer ${newToken}`,
      },
    };
  }, []);

  return (
    <div>
       <HeaderMenu title="Change Password"/>
      <div style={{ width:'50%', margin:"20px auto", textAlign:"left"}}>
        <form onSubmit={changePass}>
          <div>
            <label htmlFor="currentPassword">Current Password</label><br/>
            <input type="password" id="currentPassword" className='inputsearch' />
          </div>
          <div>
            <label htmlFor="newPassword">New Password</label> <br/>
            <input type="password" id="newPassword" className='inputsearch'  />
          </div>
          <div>
            <label htmlFor="confirmPassword">Confirm Password</label><br/>
            <input type="password" id="confirmPassword"  className='inputsearch'/>
          </div>
          <button className="btn waves-effect waves-light" type="submit">Change Password</button>
        </form>
      </div>
    </div>
  );
};

export default User_c_pass;
